import type { Role } from "@/lib/permissions/types";

export interface RoleConfig {
  label: string;
  initials: string;
  badgeBg: string;
}

export const ROLE_CONFIG: Record<Role, RoleConfig> = {
  ev: { label: "Evaluator", initials: "EV", badgeBg: "bg-[#e5edf9]" },
  le: { label: "Lead Evaluator", initials: "LE", badgeBg: "bg-[#fdf2c8]" },
  pm: { label: "Project Manager", initials: "PM", badgeBg: "bg-[#fee5e2]" },
  ma: { label: "Master Approver", initials: "MA", badgeBg: "bg-[#f0e2fe]" },
  ca: { label: "Content Admin", initials: "CA", badgeBg: "bg-neutral-100" },
};

export const SELECTABLE_ROLES: Role[] = ["ev", "le", "pm", "ma", "ca"];
